import type { DashboardToday } from "@/types/models";

// What a day's tiles show. `?? true`: a backend without the flags reads as
// logged, which is what the tiles did before.
export function eggsOf(d: DashboardToday): number | null {
  return (d.eggs_logged ?? true) ? d.total_eggs : null;
}
export function feedOf(d: DashboardToday): number | null {
  return (d.feed_logged ?? true) ? d.total_feed_kg : null;
}
// Deaths are entered only when there are some, so a day with eggs or feed
// and no mortality row is 0 deaths. Only a day with nothing at all is
// "not logged".
export function deathsOf(d: DashboardToday): number | null {
  const any = (d.eggs_logged ?? true) || (d.feed_logged ?? true) || (d.mortality_logged ?? true);
  return any ? d.total_mortality : null;
}
